import React, { Component } from 'react';
import FormView from './form-view.component';

class FormContainer extends Component {
//put your business logic or calculations here
// use FormView for UI display only
closeForm() {
    this.props.closeForm()
}
    render() {
        const { createNew, isReadAndWrite } = this.props
        return (
            <div>
                <FormView
                    closeForm={this.closeForm.bind(this)}
                    createNew={createNew}
                                    
                    //Access Type
                    isReadAndWrite={isReadAndWrite}/>
            </div>
        );
    }
}



export default FormContainer;